import {tgxApi} from "../../../app/tgxApi";
import {
    getAuthorizationHeader,
    handleQueryError,
    handleQueryErrorAndSuccess
} from "../../../helpers/utils/RtkQueryUtils";
import {getFileName, serialize} from "../../../helpers/utils/Utils";
export const registeredScrapper = tgxApi.injectEndpoints({
    endpoints: (build) => ({

        searchRegisteredScrapper: build.query({
            query: (data) => {
                // Serialize the data to query parameters
                let paramData = serialize(data);
                return {
                    url: `ajax/get-registered-scrapers?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader()
                };
            },
            providesTags: ['registeredScrapper'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await handleQueryError(queryFulfilled)
            },
        }),


        toggleWorkerDisabledStatus: build.mutation({
            query: (id) => {
                return {
                    url: `/ajax/toggle-scraper-disabled/${id}`,
                    method: 'PUT',
                    headers: getAuthorizationHeader(),
                };
            },
            invalidatesTags: ['registeredScrapper'],
            async onQueryStarted(_, {queryFulfilled,}) {
                await  handleQueryErrorAndSuccess(queryFulfilled,"Updated","System Property")
            },
        }),

    }),
});


export const {
    useToggleWorkerDisabledStatusMutation,
    useSearchRegisteredScrapperQuery,
} = registeredScrapper;